var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",class:{'theme-dark': _vm.dark}},[_c('span',{staticClass:"loading-point loading-point-1"}),_c('span',{staticClass:"loading-point loading-point-2"}),_c('span',{staticClass:"loading-point loading-point-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }